const faqs = [
  {
    q: '樱花TV是免费的吗？需要注册吗？',
    a: '樱花TV完全免费，无需注册、无需付费、无需订阅会员。打开网站即可直接观看所有影视内容，零成本享受海量日剧美剧、国产电视剧、华语电影和欧美大片。',
  },
  {
    q: '视频播放卡顿吗？画质怎么样？',
    a: '樱花TV采用智能CDN加速技术，视频秒开秒播，播放流畅不缓冲。所有内容均支持1080P全高清画质，在良好网络环境下可享受影院级观影体验。如遇卡顿，建议检查本地网络或切换网络环境。',
  },
  {
    q: '更新频率如何？能看最新剧集吗？',
    a: '我们每日更新超过30部影视内容，涵盖最新热播日剧美剧、国产电视剧、华语电影和欧美大片。热门剧集在首播后第一时间上线，确保观众能及时追更。',
  },
  {
    q: '手机上能看吗？需要下载APP吗？',
    a: '樱花TV完美适配手机和平板等移动端设备，无需下载任何APP。直接用手机浏览器访问即可观看，界面自动适配屏幕大小，随时随地畅享高清影视体验。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              你可能想知道的一切
            </p>
          </div>

          <div className="max-w-[800px] mx-auto space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-lg border border-background-200/60 p-5 md:p-6"
              >
                <h3 className="text-base font-semibold text-foreground-900 flex items-start gap-3">
                  <span className="text-primary-500 font-heading text-lg shrink-0">Q</span>
                  {faq.q}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex items-start gap-3">
                  <span className="text-accent-500 font-heading text-lg shrink-0">A</span>
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}